export const foliageWindVertHead = /* glsl */ `
uniform float uTime;
uniform float uWindSpeed;
uniform vec2  uWindDirection;
uniform float uWindDivergence;
uniform float uWindStrength;

float fw_hash(vec2 p) {
  p = fract(p * vec2(127.1, 311.7));
  p += dot(p, p + 19.19);
  return fract(p.x * p.y);
}
float fw_noise(vec2 p) {
  vec2 i = floor(p); vec2 f = fract(p);
  vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(mix(fw_hash(i),fw_hash(i+vec2(1,0)),u.x),mix(fw_hash(i+vec2(0,1)),fw_hash(i+vec2(1,1)),u.x),u.y);
}
vec2 fw_rot2(vec2 v, float a) { float s=sin(a),c=cos(a); return vec2(v.x*c-v.y*s,v.x*s+v.y*c); }
`

// Injected after #include <begin_vertex> — transformed is already declared
export const foliageWindVertBody = /* glsl */ `
  vec2 fw_wpos = vec2(instanceMatrix[3][0], instanceMatrix[3][2]);
  vec2 fw_dirA = fw_rot2(uWindDirection,  uWindDivergence);
  vec2 fw_dirB = fw_rot2(uWindDirection, -uWindDivergence);
  float fw_noiseA = fw_noise(fw_wpos * 0.15 + fw_dirA * uTime * uWindSpeed);
  float fw_noiseB = fw_noise(fw_wpos * 0.47 + fw_dirB * uTime * uWindSpeed * 3.14159);
  float fw_wind   = clamp(fw_noiseA * fw_noiseB, 0.0, 1.0);
  float fw_heightT = clamp(transformed.y / 1.0, 0.0, 1.0);
  float fw_angle = fw_wind * uWindStrength * fw_heightT * fw_heightT;
  float fw_sa = sin(fw_angle); float fw_ca = cos(fw_angle);
  vec3 fw_axis = normalize(vec3(-uWindDirection.y, 0.0, uWindDirection.x));
  transformed = transformed * fw_ca + cross(fw_axis, transformed) * fw_sa + fw_axis * dot(fw_axis, transformed) * (1.0 - fw_ca);
`
